export default "__VITE_ASSET__B4RFK5Gj__"